<template>
  <div class="results-widget">
    <v-subheader>{{ lang.orders.results.title }}</v-subheader>
    <v-row
      v-for="(result, i) in results"
      :key="i"
      class="result"
    >
      <v-col cols="9" class="result-label">
        {{ lang.orders.results[i] }}
      </v-col>
      <v-col cols="3" class="result-text">
        {{ result }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    data () {
      return (this.customData ? (this.socketInfo.custom_data ? this.socketInfo.custom_data.orders : []) : (this.get_data ? this.get_data.orders : []))
    },
    results () {
      return {
        all: (this.data || []).length,
        canceled: (this.data.filter(el => el.status === 6) || []).length,
        deleted: (this.data.filter(el => el.deleted === 1) || []).length,
        unpaid: (this.data.filter(el => el.paid === 0) || []).length
      }
    }
  }
}
</script>
